import { Component } from '@angular/core';
import { MessageService } from '../../services/message.service';
import { Router } from '@angular/router';
import { AlertController, ToastController } from '@ionic/angular';

@Component({
  selector: 'app-personal-messages',
  templateUrl: './personal-messages.page.html',
  styleUrls: ['./personal-messages.page.scss'],
})
export class PersonalMessagesPage {
  messages: any = [];
  is_dark_mode = false;
  constructor(
    private messageService: MessageService,
    private router: Router,
    public alertController: AlertController,
    public toastController: ToastController,
  ) {}
  
  ionViewWillEnter(){
    let isDark = localStorage.getItem('dark_mode');
    if(isDark == 'true'){
      this.is_dark_mode = true;
    }else{
      this.is_dark_mode = false;
    }
    localStorage.removeItem('message_badge_count');
    this.getMessageListing();
  }

  async getMessageListing(){
    await this.messageService.getMessages().subscribe( 
      response => {  
        this.messages = response.data;
      },
      error => {
        console.log(error);
      }
    ); 
  }

  messageDetail(id:number){
    this.router.navigateByUrl(`personal-message-detail/${ id }`);
  }

  backPage(){
    this.router.navigate(['dashboard']);
  }

  backHome(){
    this.router.navigate(['home']);
  }

  async deleteMessage(id:number) {
    const alert = await this.alertController.create({
      cssClass: 'new-message',
      message: '<p>Die Nachricht wird aus Ihrem Konto gelöscht!</p>',
      buttons: [
        {
          text: 'ABBRECHEN',
          role: 'cancel'
        }, {
          text: 'OK',
          handler: () => {
            this.deleteMessageRequest(id);
          }
        }
      ]
    });
    await alert.present();
  }

  deleteMessageRequest(id){
    const data = {id:id}
    this.messageService.deleteMessage(data).subscribe( 
      response => {     
        this.presentToast(response.message); 
        setTimeout(() => {
          window.location.reload();
        }, 1000);
    },
    error => {
      this.presentToast(error.error.message);       
    })
  }

  async newMeg() {
    const alert = await this.alertController.create({
      cssClass: 'new-message',
      header: 'Ihre Mitteilung',
      message: '<p>Bitte geben Sie Ihre Nachricht in das Textfeld ein</p>',
      inputs: [        
        {
          name: 'new_message',
          id: 'new_message',
          type: 'textarea',
          placeholder: 'Ihre Nachricht an uns'
        }
      ],
      buttons: [
        {
          text: 'ABBRECHEN',
          role: 'cancel'
        }, {
          text: 'Absenden',
          handler: (alertData) => {
            this.sendNewMessage(alertData.new_message);
          }
        }
      ]
    });
    await alert.present();
  }

  sendNewMessage(message){
    const data = {message:message, type:'Normal-Message'}
    this.messageService.newMessage(data).subscribe( 
      response => {     
        this.presentToast(response.message); 
    },
    error => {
      this.presentToast(error.error.message);       
    })
  }

  async presentToast(error_msg) {
    const toast = await this.toastController.create({
      cssClass:'toast-custom-class',
      message: error_msg,
      duration: 2000
    });
    toast.present();
  }
}
